// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_headingWrapper__hBs\\+u {
  text-align: left;
}

.styles_content__cerMB {
  cursor: default;
  display: none;
  margin: 0;
  margin-top: 8px;
  border: 0;
  font-weight: 300;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.015em;
  text-align: left;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 1200px) {
  .styles_content__cerMB {
    font-size: 14px;
  }
}

.styles_contentActive__ExUBo {
  cursor: auto;
  display: inline-block;
}

.styles_button__X9hn7 {
  position: relative;
  z-index: 1;
  border: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 24px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.7);
  background: transparent;
}
@media (max-width: 1200px) {
  .styles_button__X9hn7 {
    font-size: 16px;
  }
}

.styles_buttonActive__mNgvi {
  color: #ffffff;
}

.styles_labelInfo__DywbX {
  display: none;
  align-items: end;
  gap: 12px;
  margin-top: 8px;
  padding: 13px 16px;
  width: -moz-fit-content;
  width: fit-content;
  opacity: 0;
  height: 0;
  font-weight: 300;
  font-size: 18px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
}

.styles_labelInfoActive__xTwlS {
  cursor: pointer;
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  opacity: 1;
  height: auto;
}

.styles_breakLine__b5AKD {
  display: none;
}

.styles_breakLineActive__qzTPL {
  display: initial;
}

.styles_link__AjhBf {
  cursor: default;
  display: none;
  margin: 0;
  margin-top: 8px;
  border: 0;
  font-weight: 300;
  font-size: 18px;
  letter-spacing: -0.015em;
  color: #ff136d;
}
@media (max-width: 1200px) {
  .styles_link__AjhBf {
    font-size: 14px;
  }
}

.styles_linkActive__JwNuq {
  cursor: pointer;
  display: inline-block;
}

.styles_heading__UXZ1S {
  cursor: default;
  display: none;
  margin: 0;
  margin-top: 8px;
  border: 0;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 1200px) {
  .styles_heading__UXZ1S {
    font-size: 14px;
  }
}

.styles_headingActive__BjCnY {
  display: inline-block;
}

.styles_table__eRHUK {
  display: none;
}

.styles_tableActive__6d3ie {
  display: block;
}

.styles_list__W7Jhm {
  display: none;
  list-style-type: none;
}

.styles_listActive__TfW2E {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/pages/FAQ/content/accordionItem/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,+BCVS;ADQX;AEGE;EFZF;IAcI,eAAA;EADF;AACF;;AAIA;EACE,YAAA;EACA,qBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,+BClCS;EDmCT,uBAAA;AADF;AEtBE;EFWF;IAeI,eAAA;EAAF;AACF;;AAGA;EACE,cClDM;ADkDR;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,+BCzDS;ED0DT,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,UAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,cCpFK;ADoFP;AE3EE;EFkEF;IAYI,eAAA;EACF;AACF;;AAEA;EACE,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,+BC3GS;AD4GX;AEjGE;EFuFF;IAYI,eAAA;EAEF;AACF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,aAAA;EACA,qBAAA;AAEF;;AACA;EACE,cAAA;AAEF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.headingWrapper {\n  text-align: left;\n}\n\n.content {\n  cursor: default;\n  display: none;\n  margin: 0;\n  margin-top: 8px;\n  border: 0;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 25px;\n  letter-spacing: -0.015em;\n  text-align: left;\n  color: $white-80;\n\n  @include xl {\n    font-size: 14px;\n  }\n}\n\n.contentActive {\n  cursor: auto;\n  display: inline-block;\n}\n\n.button {\n  position: relative;\n  z-index: 1;\n  border: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 500;\n  font-size: 24px;\n  letter-spacing: -0.015em;\n  color: $white-70;\n  background: transparent;\n\n  @include xl {\n    font-size: 16px;\n  }\n}\n\n.buttonActive {\n  color: $white;\n}\n\n.labelInfo {\n  display: none;\n  align-items: end;\n  gap: 12px;\n  margin-top: 8px;\n  padding: 13px 16px;\n  width: fit-content;\n  opacity: 0;\n  height: 0;\n  font-weight: 300;\n  font-size: 18px;\n  letter-spacing: -0.015em;\n  color: $white-80;\n  border-radius: 8px;\n}\n\n.labelInfoActive {\n  cursor: pointer;\n  display: flex;\n  width: fit-content;\n  opacity: 1;\n  height: auto;\n}\n\n.breakLine {\n  display: none;\n}\n\n.breakLineActive {\n  display: initial;\n}\n\n.link {\n  cursor: default;\n  display: none;\n  margin: 0;\n  margin-top: 8px;\n  border: 0;\n  font-weight: 300;\n  font-size: 18px;\n  letter-spacing: -0.015em;\n  color: $pink;\n\n  @include xl {\n    font-size: 14px;\n  }\n}\n\n.linkActive {\n  cursor: pointer;\n  display: inline-block;\n}\n\n.heading {\n  cursor: default;\n  display: none;\n  margin: 0;\n  margin-top: 8px;\n  border: 0;\n  font-weight: 500;\n  font-size: 18px;\n  letter-spacing: -0.015em;\n  color: $white-80;\n\n  @include xl {\n    font-size: 14px;\n  }\n}\n\n.headingActive {\n  display: inline-block;\n}\n\n.table {\n  display: none;\n}\n\n.tableActive {\n  display: block;\n}\n\n.list {\n  display: none;\n  list-style-type: none;\n}\n\n.listActive {\n  display: block;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingWrapper": `styles_headingWrapper__hBs+u`,
	"content": `styles_content__cerMB`,
	"contentActive": `styles_contentActive__ExUBo`,
	"button": `styles_button__X9hn7`,
	"buttonActive": `styles_buttonActive__mNgvi`,
	"labelInfo": `styles_labelInfo__DywbX`,
	"labelInfoActive": `styles_labelInfoActive__xTwlS`,
	"breakLine": `styles_breakLine__b5AKD`,
	"breakLineActive": `styles_breakLineActive__qzTPL`,
	"link": `styles_link__AjhBf`,
	"linkActive": `styles_linkActive__JwNuq`,
	"heading": `styles_heading__UXZ1S`,
	"headingActive": `styles_headingActive__BjCnY`,
	"table": `styles_table__eRHUK`,
	"tableActive": `styles_tableActive__6d3ie`,
	"list": `styles_list__W7Jhm`,
	"listActive": `styles_listActive__TfW2E`
};
export default ___CSS_LOADER_EXPORT___;
